import { Source } from '@/app/system/guest/Source';
import { useLocalStorage } from '@/shared/composition/useLocalStorage';

const apiSvcUrl = useLocalStorage('api-svc-url', process.env.API_BASE_URL, true);
const apiBitrixUrl = useLocalStorage('api-bitrix-url', process.env.BITRIX_URL, true);
const apiLanderUrl = useLocalStorage('api-lander-url', process.env.LANDER_URL || 'https://syn.su/', true);
const apiSsoUrl = useLocalStorage('api-keycloak-url', process.env.SSO_URL);
const disableKeycloak = useLocalStorage('disable-keycloak', process.env.DISABLE_KEYCLOAK);
const disableRedirect = useLocalStorage('disable-redirect', process.env.DISABLE_REDIRECT);

const debugMode = useLocalStorage('debug-mode', false);
const fakeKeycloak = useLocalStorage('fake-keycloak', null, true);

export const configEnv = Object.freeze({
  SSO_URL: apiSsoUrl.value || 'https://authdev2.synergy.ru',
  SSO_REALM: process.env.SSO_REALM || 'clients',
  SENTRY_DSN: process.env.SENTRY_DSN || null,

  BITRIX_URL: apiBitrixUrl.value,
  LANDER_URL: apiLanderUrl.value,
  SYNERGY_URL: 'https://synergy.ru/',
  SYNERGY_PRIVACY_URL: 'https://synergy.ru/lp/privacy-common/',
  PACKAGE_VERSION: process.env.PACKAGE_VERSION,
  LAND_URL: 'https://friends.synergy.ru/',
  MLK_URL: process.env.MLK_URL,

  MOSAP_CLIENT_ID: process.env.MOSAP_CLIENT_ID,
  SYN_CLIENT_ID: process.env.SYN_CLIENT_ID,
  MTI_CLIENT_ID: process.env.MTI_CLIENT_ID,
  PEOPLE_CLIENT_ID: process.env.PEOPLE_CLIENT_ID,

  PROJECT_NAME: process.env.PROJECT_NAME || 'synergy',

  VUE_APP_ENVIRONMENT: process.env.VUE_APP_ENVIRONMENT,

  VUE_APP_KEYCLOAK_URL: process.env.VUE_APP_KEYCLOAK_URL,
  VUE_APP_KEYCLOAK_REALM: process.env.VUE_APP_KEYCLOAK_REALM,
  VUE_APP_KEYCLOAK_CLIENT_ID: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
  VUE_APP_LOYALTY_API_URL: apiSvcUrl.value,

  VUE_APP_SF_CLIENT: process.env.VUE_APP_SF_CLIENT,
  VUE_APP_MOI_CLIENT: process.env.VUE_APP_MOI_CLIENT,
  VUE_APP_MS_CLIENT: process.env.VUE_APP_MS_CLIENT,
  VUE_APP_SP_CLIENT: process.env.VUE_APP_SP_CLIENT,
  VUE_APP_PEOPLE_CLIENT: process.env.VUE_APP_PEOPLE_CLIENT,

  VUE_APP_SF_URL: process.env.VUE_APP_SF_URL,
  VUE_APP_MC_URL: process.env.VUE_APP_MC_URL,
  VUE_APP_MS_URL: process.env.VUE_APP_MS_URL,
  VUE_APP_SP_URL: process.env.VUE_APP_SP_URL,

  DISABLE_REDIRECT: disableRedirect.value,

  DADATA_URL: process.env.VUE_APP_DADATA_URL,
  DADATA_TOKEN: process.env.VUE_APP_DADATA_TOKEN,

  DEBUG_MODE: process.env.VUE_APP_ENVIRONMENT === 'development' && debugMode.value,
  // Возможность отключить кейклок только для дев сборки - нужно для тестов
  DISABLE_KEYCLOAK: process.env.VUE_APP_ENVIRONMENT === 'development' ? disableKeycloak.value : false,
  FAKE_KEYCLOAK: process.env.VUE_APP_ENVIRONMENT === 'development' ? fakeKeycloak.value : false,

  breakpoints: {
    mobile: 425,
    tablet: 768,
  },
});

export const configSource = new Source(configEnv);
